export default __webpack_public_path__ + "static/media/news.14b2e477.jpg";